/**
 * Utility functions for badge levels and colors
 */

import type { BadgeLevel } from '@/types';

/**
 * Get premium color for badge level
 */
export function getBadgeLevelColor(level?: BadgeLevel | string | null): string {
  if (!level) return 'bg-neutral-700 text-neutral-400 light:bg-neutral-200 light:text-neutral-700';
  
  const levelLower = level.toLowerCase();
  
  switch (levelLower) {
    case 'junior':
      // Dark: премиальный серый; Light: мягкий серый чип с темным текстом
      return 'bg-neutral-600/80 text-neutral-300 light:bg-neutral-200 light:text-neutral-800';
    case 'middle':
      return 'bg-blue-600/80 text-blue-200 light:bg-blue-100 light:text-blue-700';
    case 'senior':
      return 'bg-purple-600/80 text-purple-200 light:bg-purple-100 light:text-purple-700';
    case 'lead':
      return 'bg-amber-600/80 text-amber-200 light:bg-amber-100 light:text-amber-700';
    case 'expert':
      // Для светлой темы поддержим градиент через те же цвета
      return 'bg-gradient-to-r from-amber-500 to-orange-500 text-white light:from-amber-400 light:to-orange-400';
    default:
      return 'bg-neutral-700 text-neutral-400 light:bg-neutral-200 light:text-neutral-700';
  }
}

/**
 * Get color for verification score
 */
export function getScoreColor(score?: number | null): string {
  if (score === null || score === undefined) return 'text-white';
  
  if (score < 50) {
    return 'text-white'; // Белый для низких баллов
  } else {
    return 'text-primary-400'; // Синий для высоких баллов
  }
}

/**
 * Capitalize badge level (Junior, Middle, Senior, Lead, Expert)
 */
export function capitalizeBadgeLevel(level?: BadgeLevel | string | null): string {
  if (!level) return '';
  return level.charAt(0).toUpperCase() + level.slice(1);
}

